import useStyles from '../../../../../style/js-style/containers/administration/calculator/CalculatorDialogStyle';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { hasInnerField, isComplexListSubField, VariableContext } from '../../../../../services/common/CalculatorUtils';
import { useFormContext } from 'react-hook-form';
import _ from 'lodash';
import CalculatorSelectInput from '../calculatorInputs/CalculatorSelectInput';
import i18next from 'i18next';


const DynamicSubTargetField = ({ fieldName, availableFields, level, readOnly = false }) => {
  const { classes } = useStyles();

  const {
    onVariableChangeCallBack,
    currentVariable
  } = useContext(VariableContext);

  const formMethods = useFormContext();
  const {
    setValue,
    getValues
  } = formMethods;

  const [availableSubFields, setAvailableSubFields] = useState();

  const clearSubFieldsValues = useCallback(
(initLevel = 1) => {
         const obj = getValues(fieldName) || {};

         Object.keys(obj)
         .filter((k) => k.startsWith("intermediatefield-"))
         .map((k) => ({ key: k, idx: Number(k.replace("intermediatefield-", "")) }))
         .filter(({ idx }) => Number.isFinite(idx) && idx >= initLevel)
         .forEach(({ key }) => {
            setValue(`${fieldName}.${key}`, undefined);
         });
    },
[fieldName, getValues, setValue]
  );

  useEffect(() => {
    //in case we show intermediate field to define the variable, we remove preexisting value if not in the availableFields
    let entry = _.find(availableFields, { value:  getValues(`${fieldName}.intermediatefield-${level}`) });
    if(!entry) {
      setValue(`${fieldName}.intermediatefield-${level}`, undefined);
      setAvailableSubFields(undefined);
    } else if(entry && !availableSubFields) {
      //if intermediatefield is set but not de availableSubFields
      setAvailableSubFields(entry.subFields ? entry.subFields : undefined);
    }
  }, [availableFields, availableSubFields, fieldName, getValues, level, setValue])

  const onFieldChange = useCallback((newValue) => {
    let entry = _.find(availableFields, { value: newValue });
    if (entry.subFields) {
      setValue(`${fieldName}.field_type`, undefined);
      setValue(`${fieldName}.field`, undefined);
      setValue(`${fieldName}.inner_field`, undefined);
      clearSubFieldsValues();
    } else if (isComplexListSubField(entry)) {
        setValue(`${fieldName}.field`, entry.path[0]);
        setValue(`${fieldName}.field_type`, entry.type);
        setValue(`${fieldName}.field_sub_type`, entry.subType);
        setValue(`${fieldName}.target_field_nature`, entry.fieldNature);
        setValue(`${fieldName}.inner_field`, undefined);
        setValue(`${fieldName}.complex_list_sub_field.field`, entry.complexListSubField.label);
        setValue(`${fieldName}.complex_list_sub_field.field_type`, entry.complexListSubField.type);
    } else if ((level > 0) && hasInnerField(entry)) {
      const parentFieldValue = getValues(`${fieldName}.intermediatefield-${level - 1}`);

      setValue(`${fieldName}.field`, parentFieldValue);
      setValue(`${fieldName}.field_type`, entry.type);
      setValue(`${fieldName}.inner_field`, entry.value)
      setValue(`${fieldName}.field_sub_type`, entry.subType || ``);
      setValue(`${fieldName}.target_field_nature`, entry.fieldNature);
    } else {
      setValue(`${fieldName}.field`, entry.value);
      setValue(`${fieldName}.field_type`, entry.type);
      setValue(`${fieldName}.field_sub_type`, entry.subType || ``);
      setValue(`${fieldName}.target_field_nature`, entry.fieldNature);
      setValue(`${fieldName}.inner_field`, undefined);
    }

    setAvailableSubFields(entry.subFields ? entry.subFields : undefined);

  }, [availableFields, getValues, setValue, fieldName, clearSubFieldsValues, level]);


  return (
    <>
      <div className={classes.variableDivider}> / </div>

      <CalculatorSelectInput
        fieldName={`${fieldName}.intermediatefield-${level}`}
        label={``}
        isRequired
        placeholder={i18next.t(
          `calculator.dialog.create.placeholder.selectValue`
        )}
        options={availableFields}
        onChange={(newValue) => {
          onFieldChange(newValue);
          onVariableChangeCallBack(currentVariable, `intermediatefield-${level}`);
        }}
        validate={() => {
          return null;
        }}
        variant="standard"
        labelVariant="standard"
        className={classes.inputPathVariableItem}
        disabled={readOnly}
      />
      {availableSubFields &&
        <DynamicSubTargetField fieldName={`${fieldName}`} availableFields={availableSubFields} level={level+1} readOnly={readOnly} />
      }
    </>
  );
}


export default DynamicSubTargetField;